















































// @ is an alias to /src
import {Component, Vue, Watch} from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import BaseMap from "@/components/BaseMap.vue";
import CiazCar from "@/components/cars/Ciaz.vue";
import ErtigaCar from "@/components/cars/Ertiga.vue";
import IgnisCar from "@/components/cars/Ignis.vue";
import SCrossCar from "@/components/cars/SCross.vue";
import SwiftCar from "@/components/cars/Swift.vue";
import SwiftSportCar from "@/components/cars/SwiftSport.vue";
import SwiftSportCar2021 from "@/components/cars/SwiftSport2021.vue";
import ERtigaBoostergreen from "@/components/cars/ErtigaBoostergreen.vue";
import VitaraCar from "@/components/cars/Vitara.vue";
import Ciaz2021 from "@/components/cars/Ciaz2021.vue";
import Ertiga2021 from "@/components/cars/Ertiga2021.vue";
import Swift2021 from "@/components/cars/Swift2021.vue";
import GrandVitra from "@/components/cars/GrandVitra.vue";
import ErtigaXL7Boostergreen from "@/components/cars/ERTIGAXL7BOOSTERGREEN.vue";

import FRONXBOOSTERGREENGLX from "@/components/cars/FRONXBOOSTERGREENGLX.vue";
import SWiftBoostergreen2025 from "@/components/cars/Nuevo-SwiftBoostergreen-2025.vue";


import Baleno from "@/components/cars/baleno.vue";
import SWiftBoostergreen from "@/components/cars/SwiftBoostergreen.vue";

import Jimny from "@/components/cars/jimny.vue";
import Jimny5door from "@/components/cars/JIMNY5DOOR.vue";




import Formulario from "@/components/Formulario.vue";

const UIkit = require("@/assets/uikit/js/uikit");
// var UIkit:any;

@Component({
  components: {
    FRONXBOOSTERGREENGLX,
    GrandVitra,
    Navbar,
    Footer,
    CiazCar,
    ErtigaCar,
    IgnisCar,
    SCrossCar,
    SwiftCar,
    SwiftSportCar,
    VitaraCar,
    Ciaz2021,
    Ertiga2021,
    Swift2021,
    Baleno,
    Jimny,
    Jimny5door,
    SWiftBoostergreen,
    ERtigaBoostergreen,
    BaseMap,
    Formulario,
    ErtigaXL7Boostergreen,
    SwiftSportCar2021, 
    SWiftBoostergreen2025
    
  },
})
export default class DetalleAuto extends Vue {

  public clickedModel: string = ""; // modelo
  public modalTitle: string = ""; // TITULO
  public origin: string = ""; // ORIGIN
  public interes: string = ""; // INTERES
  public version: string = ""; // Version

  openModalDetalle(data:any) {

    this.clickedModel = data.auto;
    this.modalTitle = data.titulo;
    this.interes = data.interes;
    this.version = data.version;


    UIkit.modal("#detalleModal").show();
    
  }



}
